export default "__VITE_ASSET__Bhz5Bxg4__"